export const Task =(props)=>{
    return ( 
        <div   
            className="desc" 
            style={{ backgroundColor : props.completed ? "#a9ce9a" :"pink"}}
            
        >
              <h1>{props.taskName}</h1>
              <button className="buttoncomplete" onClick={() => props.completeTask(props.id)}>Completed</button>
              {/* {props.todo &&<h1 style={{color:"red"}}>Heey You Hide Me</h1> } */}
              <button className='buttondelete' onClick={()=>props.deleteTask(props.id)}>Delete</button>
              </div>
          );
}

// export const Task = (props) => {
//     return (
//       <div
//         className="task"
//         style={{ backgroundColor: props.completed ? "green" : "white" }}
//       >
//         <h1>{props.taskName}</h1>
//         <button onClick={() => props.completeTask(props.id)}> Complete </button>
//         <button onClick={() => props.deleteTask(props.id)}> X </button>
//       </div>
//     );
//   };